import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { navBarContainer, toggleButtonsGroupLayout } from "./UsageStyle";
import MonthNavigator from "./MonthNavigator";

const Navbar = ({
  setIsExperiments,
  isExperiments,
  date,
  setDate,
  minDate,
  maxDate,
}) => {
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      setIsExperiments(newAlignment === "experiments");
    }
  };

  return (
    <Box sx={navBarContainer}>
      <ToggleButtonGroup
        value={isExperiments ? "experiments" : "deployed"}
        exclusive
        onChange={handleAlignment}
        sx={toggleButtonsGroupLayout}
      >
        <ToggleButton value="experiments" size="small">
          Experiments
        </ToggleButton>
        <ToggleButton value="deployed" size="small">
          Deployed LLM Apps
        </ToggleButton>
      </ToggleButtonGroup>

      <MonthNavigator
        date={date}
        setDate={setDate}
        minDate={minDate}
        maxDate={maxDate}
      />
    </Box>
  );
};

export default Navbar;
